import React from 'react';

export function HongKong(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="513" height="342" fill="#DE2910"/>
      <path d="M256,171 C256,171 230,145 240,120 C245,108 256,105 256,105 C256,105 244,115 248,130 C252,145 270,148 270,165 C270,171 256,171 256,171Z" fill="white"/>
      <path d="M256,171 C256,171 224,175 218,150 C215,138 222,129 222,129 C222,129 220,143 230,150 C240,157 254,148 264,160 C267,165 256,171 256,171Z" fill="white"/>
      <path d="M256,171 C256,171 244,198 220,195 C208,193 203,183 203,183 C203,183 216,188 224,179 C232,170 226,154 240,148 C246,145 256,171 256,171Z" fill="white"/>
      <path d="M256,171 C256,171 282,192 275,216 C271,227 261,230 261,230 C261,230 266,218 259,209 C252,200 236,204 232,189 C230,183 256,171 256,171Z" fill="white"/>
      <path d="M256,171 C256,171 285,156 300,176 C307,186 303,197 303,197 C303,197 298,185 288,185 C278,185 271,199 258,196 C252,194 256,171 256,171Z" fill="white"/>
    </svg>
  );
}
